
import { useEffect, useState } from 'react';
import { useNavigate, useParams, useRoutes } from 'react-router-dom';
import { useLocation } from 'react-router-dom'
import SplashView from '../pages/Splash/Splash';
import ServerErr from '../components/Errors/500';
import ClientError from '../components/Errors/400';
import DesktopHeader from '../components/DesktopHeader/DesktopHeader';
import Menu from '../components/Menu/Menu';
import { useUserInfo } from '../pages/Profile/connect/User';
import routes from '../routes';
import { useOrders } from '../pages/DefaultPage/connect/Orders';
import DesktopSidebar from '../components/Menu/DesktopSidebar';

function DesktopLayout() {

    const showServerError = useOrders((state) => state.showServerError);
    const showClientError = useOrders((state) => state.showClientError);
    let router = useRoutes(routes)
    const location = useLocation();


    return (
        <>
            {
                showServerError ? (<ServerErr />) : (
                    showClientError ? (<ClientError />) :
                        <div className='block sm:hidden md:hidden lg:hidden relative overflow-y-hidden'>
                            {(location.pathname !== "/LoginStepOne" && location.pathname !== "/LoginSecondStep") &&
                                <DesktopHeader />
                            }
                            {
                                location.pathname === "/" ||
                                    location.pathname.slice(0, 18) == "/buildingMaterials" ||
                                    location.pathname.slice(0, 7) == "/metals" ||
                                    location.pathname.slice(0, 15) == "/services-labor" ||
                                    location.pathname.slice(0, 10) == "/communal" ||
                                    location.pathname.slice(0, 14) == "/machine-tools" ||
                                    location.pathname.slice(0, 21) == "/architect-contractor" ||
                                    location.pathname.slice(0, 20) == "/CommissionCalculate" ||
                                    location.pathname === "/RegisterAD" ||
                                    location.pathname === "/AdsOnMap" ||
                                    location.pathname === "/CategoryView" ||
                                    location.pathname === "/" ||
                                    location.pathname === "/LoginStepOne" ||
                                    location.pathname === "/LoginLocation" ||
                                    location.pathname === "/LoginSecondStep" ||
                                    location.pathname === "/LoginStepThird" ||
                                    location.pathname.slice(0, 9) === "/property" ||
                                    location.pathname.slice(0, 16) === "/AdvertiseDetail" ||
                                    location.pathname.slice(0, 14) === "/EditforMySelf" ||
                                    location.pathname.slice(0, 9) === "/ChatPage" ||
                                    location.pathname.slice(0, 11) === "/FollowPage" ||
                                    // location.pathname === "/Messages" ||
                                    location.pathname === "/SplashView" ||
                                    location.pathname === "/CurrenciesPage" ||
                                    location.pathname === "/invitaion" ||
                                    location.pathname.slice(0, 5) === "/edit" ||
                                    location.pathname.slice(0, 16) === "/allads/generic" ||
                                    location.pathname.slice(0, 17) === "/allads/personal" ||
                                    location.pathname.slice(0, 17) === "/allads/communal" ||
                                    location.pathname.includes("Blog") ||
                                    location.pathname.includes("blog") ||
                                    location.pathname.includes("PickCategory") ||
                                    location.pathname.includes("buyAndSell") ||
                                    location.pathname.includes("Rent") ||
                                    location.pathname.includes("exchange") ||
                                    location.pathname.includes("all") ||
                                    location.pathname.includes("Participation") ||
                                    location.pathname.includes("Purchaser") ||
                                    location.pathname.includes("Renter") ||
                                    location.pathname.includes("PreSale") ||
                                    location.pathname.includes("ShortRent") || 
                                    location.pathname.includes("CreateFile") ||
                                    location.pathname.includes("ConstructorsList") ||
                                    location.pathname.includes("Tutorial") 
                                  

                                    ? (

                                        <div className='grid grid-cols-1 gap-2 mt-[7rem] lg:mt-0 '>
                                            {router}
                                        </div>
                                    ) : (
                                        <div className='grid grid-cols-6 gap-2 '>
                                            <DesktopSidebar />
                                            <div className='grid col-span-5 xl:col-span-5 2xl:col-span-5 mt-[7rem]'>
                                                {router}
                                            </div>
                                        </div>
                                    )
                            }
                        </div>
                )
            }
        </>
    )
}

export default DesktopLayout